import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAttrs } from "vue";


import { defineComponent, computed } from "vue";
const __default__ = defineComponent({
  name: "VZLabel",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const attrs = useAttrs();
// eslint-disable-next-line vue/return-in-computed-property
const dynamicAttrs = computed(() => {
  const clonedAttrs = { ...attrs };

  // Check if attrs.style.defaultFonts is "true !important"
  if (
    clonedAttrs.style &&
    clonedAttrs.style.defaultFonts === "true !important"
  ) {
    // If true, reset style to an empty object
    clonedAttrs.style.fontFamily = "";
    clonedAttrs.style.fontSize = "";
    clonedAttrs.style.fontWeight = "";
    clonedAttrs.style.fontStyle = "";
    clonedAttrs.style.color = "";
    clonedAttrs.fontFamily = "";
    clonedAttrs.fontSize = "";
    clonedAttrs.fontWeight = "";
    clonedAttrs.fontStyle = "";
    clonedAttrs.color = "";
  }
  if (
    clonedAttrs.style &&
    clonedAttrs.style.defaultBorder === "true !important"
  ) {
    clonedAttrs.style.borderColor = "";
    clonedAttrs.style.borderWidth = "";
    clonedAttrs.style.borderStyle = "";
    clonedAttrs.style.padding = "";
    clonedAttrs.style.margin = "";
    clonedAttrs.borderColor = "";
    clonedAttrs.borderWidth = "";
    clonedAttrs.borderStyle = "";
    clonedAttrs.padding = "";
    clonedAttrs.margin = "";
  }

  return clonedAttrs;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _mergeProps(_unref(dynamicAttrs), { class: "VZ_TABLE_BUTTON" }), _toDisplayString(_unref(attrs).label), 17))
}
}

})